import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { getEmptyLocation, Location } from 'src/app/interfaces/location';
import { AuthService } from 'src/app/services/auth.service';
import { LocationService } from 'src/app/services/location.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-locationlist',
  templateUrl: './locationlist.component.html',
  styleUrls: ['./locationlist.component.scss'],
})
export class LocationlistComponent implements OnInit {
  locations: any[] = [];
  location: any;
  locationLocal: any;
  currentLocationId: string;
  companyid: any;
  loading: boolean = false;
  token: any;


  constructor(
    private route: ActivatedRoute,
    private storage: Storage,
    private locationService: LocationService,
    private alertController: AlertController,
    private toastS: ToastService,
    private authService: AuthService
  ) {
    this.locationService.locationSave.subscribe(async x => { // 617287c7046b1c002d8e66c5
      this.foundIndex(x);
      console.log("locationSave: ", x);
      this.locationService.getAllLocations(this.companyid).subscribe(x => {
        this.locations = x;
        // this.storage.set(environment.storage.locations, x);
        console.log('getAllLocations: ', this.locations);
        this.loading = false;
        // this.addNewLocation();
      });

      // this.addNewLocation();
    });
  }

  async ngOnInit() {
    this.token = await this.authService.getDecodedUserToken();
    this.companyid = this.token.company;
    if (this.companyid) {
      this.loading = true;
      this.locationService.getAllLocations(this.companyid).subscribe(x => {
        this.locations = x;
        // this.storage.set(environment.storage.locations, x);
        console.log('getAllLocations: ', this.locations);
        this.loading = false;
        // this.addNewLocation();
      });
    }
  }

  ionViewWillEnter() {
  }

  foundIndex(location) {
    let emptyElementIndex = this.locations.findIndex(index => index._id === undefined);
    if (emptyElementIndex > -1) {
      this.locations.splice(emptyElementIndex, 1);
    }
    let index = this.locations.findIndex(y => y._id == (location as Location)._id);
    this.currentLocationId = (location as Location)?._id;
    if (index != -1) {
      this.locations[index] = location;
    } else {
      this.locations.unshift(location);
    }
  }

  edit(location) {
    this.foundIndex(location);
    this.locationService.locationDataSubject.next(location);//new Subjekt Ermitter
  }

  addNewLocation() {
    let locEmpty = getEmptyLocation();
    locEmpty.company = this.token.company;
    this.foundIndex(locEmpty);
    this.locationService.locationDataSubject.next(locEmpty);
  }

  async delete(eventid, index) {
    const alert = await this.alertController.create({
      header: 'LÖSCHEN',
      message: 'Möchtest du wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel'
        },
        {
          text: 'OK',
          role: 'ok',
          handler: () => {
            this.locationService.deleteLocation(eventid).subscribe(x => {
              console.log("Löschen funktioniert", x);
              // TODO: Toastmessage einbauen
              // TODO: AlertController als Abfrage JA, NEIN einbauen
              // local löschen
              this.locations.splice(index, 1);
              this.toastS.deleteToast();
            }, err => {
              console.log("Löschen funktioniert NICHT", err);
              this.toastS.deleteToastNot();
            })
          }
        }
      ]
    });
    alert.present();
  }
}
